<template>
    <v-dialog-old ref="dialog" id="consultantDialog">
        <fieldset>
            <legend>Пользователь</legend>

            <label>Фамилия Имя Отчество</label>
            <input type="text" v-model="consultant.fullname" class="large" readonly />

            <label>Email</label>
            <input type="email" v-model="consultant.email" class=" large" />

            <label>Телефон</label>
            <input type="text" v-model="consultant.phone" class="large" />
        </fieldset>

        <fieldset style="overflow: visible;">
            <legend>История операций</legend>

            <v-table id="paymentTransactionsTable"
                     :request-uri="'users/paymentTransactions/' + consultant.id"
                     pagesize="25"
                     ref="table">
                <template v-slot:header>
                    <v-tr>
                        <v-th name="created_at" sort="created_at" width="120">
                            Дата
                        </v-th>
                        <v-th name="amount" sort="amount" width="100">
                            Сумма
                        </v-th>
                        <v-th name="purpose" sort="purpose" minwidth="200">
                            Операция
                        </v-th>
                        <v-th name="comment" sort="comment" minwidth="200">
                            Комментарий
                        </v-th>
                    </v-tr>
                    <v-tr>
                        <v-th name="created_at" v-slot="{filter}">
                            <date-piker v-model="filter.value"/>
                        </v-th>
                        <v-th name="amount" v-slot="{filter}">
                            <v-input v-model="filter.value" />
                        </v-th>
                        <v-th name="purpose" v-slot="{filter}">
                            <v-input v-model="filter.value" />
                        </v-th>
                        <v-th name="comment" v-slot="{filter}">
                            <v-input v-model="filter.value" />
                        </v-th>
                    </v-tr>
                </template>
                <template v-slot:row="{ item, index }">
                    <v-tr class="hover" :id="'pt-tr-' + item.id">
                        <v-td name="created_at">
                            {{ item.created_at | formatDateTime }}
                        </v-td>
                        <v-td name="amount" highlight="*" align="right">
                            <span>{{ formatPrice(item.amount) }} р.</span>
                        </v-td>
                        <v-td name="purpose">
                            <span v-html="formatLink(item.purpose)"/>
                        </v-td>
                        <v-td name="comment">
                            <span>{{ item.comment }}</span>
                        </v-td>
                    </v-tr>
                </template>
            </v-table>
        </fieldset>

        <footer>
            <v-loading-component v-if="$can('admin.consult.users.update')" @click="update">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">
                        Сохранить
                    </button>
                </template>
            </v-loading-component>
            <v-loading-component v-if="$can('admin.consult.users.update') && !consultant.blocked_at" @click="block">
                <template slot-scope="{ loadingClass }">
                    <button :class="['red', loadingClass]">
                        Заблокировать
                    </button>
                </template>
            </v-loading-component>
            <v-loading-component v-if="$can('admin.consult.users.update') && consultant.blocked_at" @click="unblock">
                <template slot-scope="{ loadingClass }">
                    <button :class="['blue', loadingClass]">
                        Разблокировать
                    </button>
                </template>
            </v-loading-component>
        </footer>
    </v-dialog-old>
</template>

<script>
import { formatPrice } from "@/global/helpers";

export default {
    data: function () {
        return {
            consultant: {
                id: '',
                fullname: '',
                email: '',
                phone: '',
                blocked_at: false,
            },
            formatPrice: formatPrice,
        };
    },
    methods: {
        show (id) {
            return this.axios.post('users/read/' + id).then(response => {
                Object.assign(this.consultant, response.data);
                this.$refs.dialog.show();
            });
        },
        update: function (btn) {
            if (!this.consultant.fullname) {
                return;
            }

            btn.startLoadingAnimation();

            this.axios.post('users/update/' + this.consultant.id, this.consultant)
                .then(response => {
                    btn.stopLoadingAnimation();
                    this.$emit('updated');
                    this.$refs.dialog.hide();
                })
                .catch(response => {
                    btn.stopLoadingAnimation();
                });
        },
        block (btn) {
            btn.startLoadingAnimation();

            return this.axios.post('users/block/' + this.consultant.id).then(response => {
                btn.stopLoadingAnimation();
                this.$emit('updated');
                this.$refs.dialog.hide();
            });
        },
        unblock (btn) {
            btn.startLoadingAnimation();

            return this.axios.post('users/unblock/' + this.consultant.id).then(response => {
                btn.stopLoadingAnimation();
                this.$emit('updated');
                this.$refs.dialog.hide();
            });
        },
        formatLink (link) {
            return link.replace('<a href="', '<a target="_blank" href="');
        }
    }
}
</script>

<style lang="scss">
#consultantDialog {
    width: 900px;

    #paymentTransactionsTable {
        height: calc(100vh - 450px);
        max-height: 500px;
    }
}
</style>
